export default {
  methods: {
    fetchServiceProviders () {
      this.$http.get(`api/v1.0/service-providers`).then(response => {
        this.columns.find(
          obj => obj.name === 'service_provider_id').values = response.data.map(
          val => {
            return {
              label: val.alias,
              value: val.id,
            }
          })
      })
    },
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/fetchServiceProviders.js